import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ThemeService } from 'src/app/core/services/theme.service';

/**
 * IsThemeToggleComponent
 *
 * Botão de alternância de tema (claro/escuro).
 * Usa getters para refletir o estado atual sem subscription.
 */
@Component({
  selector: 'is-theme-toggle',
  standalone: true,
  imports: [CommonModule],
  template: `
    <button
      type="button"
      class="btn btn-sm btn-light border-0 rounded-circle d-flex align-items-center justify-content-center"
      style="width: 34px; height: 34px;"
      (click)="toggle()"
      [title]="tooltipText"
      [attr.aria-label]="tooltipText"
    >
      <i class="bx font-size-16" [ngClass]="iconClass"></i>
    </button>
  `,
  styles: [`
    :host-context([data-bs-theme="dark"]) .btn-light {
      background: rgba(255, 255, 255, 0.08) !important;
      color: #e9ecef;
    }
    :host-context([data-bs-theme="dark"]) .btn-light:hover {
      background: rgba(255, 255, 255, 0.12) !important;
    }
  `],
})
export class ThemeToggleComponent {
  constructor(private themeService: ThemeService) {}

  get iconClass(): string {
    return this.themeService.effectiveTheme === 'dark' ? 'bx-moon' : 'bx-sun';
  }

  get tooltipText(): string {
    return this.themeService.effectiveTheme === 'dark' ? 'Mudar para tema claro' : 'Mudar para tema escuro';
  }

  toggle(): void {
    this.themeService.toggle();
  }
}
